import { get } from 'lodash'
import { showErrorNotification, callAPI } from 'Shared/helpers'

export const ActionTypes = {
  CHANGE_FILTER: 'CHANGE_FILTER',
  RESET_FILTERS: 'RESET_FILTERS',
  FETCH_INITIAL_DATA_REQUEST: 'FETCH_INITIAL_DATA_REQUEST',
  FETCH_INITIAL_DATA_RECEIVED: 'FETCH_INITIAL_DATA_RECEIVED',
  FETCH_ALL_DATA_RECEIVED: 'FETCH_ALL_DATA_RECEIVED',
  ADD_TO_CART_REQUEST: 'ADD_TO_CART_REQUEST',
  ADD_TO_CART_RESPONSE: 'ADD_TO_CART_RESPONSE',
  FETCH_MORE_DATA_REQUEST: 'FETCH_MORE_DATA_REQUEST',
  FETCH_MORE_DATA_RECEIVED: 'FETCH_MORE_DATA_RECEIVED',
  FETCH_FILTERED_DATA_RECEIVED: 'FETCH_FILTERED_DATA_RECEIVED',
  FETCH_FILTERED_DATA_REQUEST: 'FETCH_FILTERED_DATA_REQUEST',
}

const fetchInitialDataRequest = () => ({
  type: ActionTypes.FETCH_INITIAL_DATA_REQUEST,
})

const fetchInitialDataReceived = (data) => ({
  type: ActionTypes.FETCH_INITIAL_DATA_RECEIVED,
  data,
})

const fetchMoreDataRequest = () => ({
  type: ActionTypes.FETCH_MORE_DATA_REQUEST,
})

const fetchMoreDataReceived = (data) => ({
  type: ActionTypes.FETCH_MORE_DATA_RECEIVED,
  data,
})

const fetchFilteredDataReceived = (data) => ({
  type: ActionTypes.FETCH_FILTERED_DATA_RECEIVED,
  data,
})

const fetchFilteredDataRequest = () => ({
  type: ActionTypes.FETCH_FILTERED_DATA_REQUEST,
})

const addToCartRequest = () => ({
  type: ActionTypes.ADD_TO_CART_REQUEST,
})

const addToCartResponse = (data) => ({
  type: ActionTypes.ADD_TO_CART_RESPONSE,
  data,
})

const changeFilterAction = (filter, value) => ({
  type: ActionTypes.CHANGE_FILTER,
  filter,
  value,
})

const resetFilters = () => ({
  type: ActionTypes.RESET_FILTERS,
})

export const clearFilters = (dispatch) => {
  dispatch(resetFilters())
}

export const changeFilter = (filter, value) => (dispatch, getState) => {
  // Only do something if filter value has changed
  if (filter == 'clear')
    clearFilters(dispatch)

  if (getState().filters[filter] !== value && filter !== 'clear')
    dispatch(changeFilterAction(filter, value))

  const state = getState()
  const tourId = state.misc.selectedTour
  if (filter !== 'viewType')
    dispatch(fetchFilteredData(tourId))
}

export const getAuthenticityToken = () => (
  $('head meta[name=\'csrf-token\']').attr('content')
)

export const addToCart = (url) => (dispatch) => {
  dispatch(addToCartRequest())
  fetch(url, {
    method: 'POST', // or 'PUT'
    body: '', // data can be `string` or {object}!
    credentials: 'include',
    headers: {
      'X-CSRF-Token': getAuthenticityToken(),
    },
  }).then((response) => Promise.all([ response, response.json() ]))
  .then(([ response, json ]) => {
    if (response.status === 200) {
      dispatch(addToCartResponse(json))
      parent.document.getElementById('shopping_cart_content').classList.remove('hidden')
      if (parent.document.getElementById('shopping_cart_continue') != null)
        parent.document.getElementById('shopping_cart_continue').classList.remove('hidden')
      parent.document.getElementById('shopping_cart_content').getElementsByClassName('cartships')[0].innerHTML = json.cartships_size
    }
  })
  .catch(showErrorNotification('Error while adding registration to cart!'))
}

export const fetchInitialData = (tourId) => (dispatch, getState) => {
  dispatch(fetchInitialDataRequest())
  const state = getState()
  const filters = state.filters

  const dataURL = state.misc.fetchInitialDataURL
  const params = {
    filter_options: filters,
    selected_tour_id: tourId,
    season_id: state.misc.seasonId,
  }
  if (dataURL) {
    callAPI(dataURL, 'GET', params)
    .then(json => {
      dispatch(fetchInitialDataReceived(json))
    })
    if (tourId && tourId !== 'all') {
      callAPI(dataURL)
      .then(json => {
        dispatch(fetchAllDataReceived(json))
      })
    }
  }
}

export const fetchFilteredData = (tourId) => (dispatch, getState) => {
  const state = getState()
  const dataIsLoading = state.misc.dataIsLoading
  if (dataIsLoading) {
    return
  }
  dispatch(fetchFilteredDataRequest())
  const filters = state.filters
  const dataURL = state.misc.fetchInitialDataURL
  // We call the filters actual filters because the same parameter is used in already embedded iFrames as something else

  const params = {
    filter_options: filters,
    selected_tour_id: tourId,
    season_id: state.misc.seasonId,
  }
  if (dataURL) {
    callAPI(dataURL, 'GET', params)
    .then(json => {
      dispatch(fetchFilteredDataReceived(json))
    })
    .then(() => {
      dispatch(fetchMoreData(tourId))
    })
    .catch(showErrorNotification('Error while fetching filtered data!'))
  }
}

export const fetchMoreData = (tourId) => (dispatch, getState) => {
  const state = getState()
  const dataIsLoading = state.misc.dataIsLoading
  if (dataIsLoading) {
    return
  }
  dispatch(fetchMoreDataRequest())
  const filters = state.filters
  const dataURL = state.misc.fetchInitialDataURL
  // We call the filters actual filters because the same parameter is used in already embedded iFrames as something else

  const params = {
    filter_options: filters,
    selected_tour_id: tourId,
    season_id: state.misc.seasonId,
    page: state.misc.page + 1,
  }

  if (dataURL) {
    callAPI(dataURL, 'GET', params)
    .then(json => {
      dispatch(fetchMoreDataReceived(json))
    })
    .catch(showErrorNotification('Error while fetching more data!'))
  }
}


